
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.57 14.915c.79 0 1.43.654 1.43 1.46 0 .806-.64 1.46-1.43 1.46-.79 0-1.43-.654-1.43-1.46 0-.806.64-1.46 1.43-1.46zm-8.57 0c.79 0 1.43.654 1.43 1.46 0 .806-.64 1.46-1.43 1.46-.79 0-1.43-.654-1.43-1.46 0-.806.64-1.46 1.43-1.46zm-8.57 0c.79 0 1.43.654 1.43 1.46 0 .806-.64 1.46-1.43 1.46-.79 0-1.43-.654-1.43-1.46 0-.806.64-1.46 1.43-1.46zm0-8.75c.79 0 1.43.654 1.43 1.46 0 .806-.64 1.46-1.43 1.46-.79 0-1.43-.654-1.43-1.46 0-.806.64-1.46 1.43-1.46zm8.57 0c.79 0 1.43.654 1.43 1.46 0 .806-.64 1.46-1.43 1.46-.79 0-1.43-.654-1.43-1.46 0-.806.64-1.46 1.43-1.46zm8.57 0c.79 0 1.43.654 1.43 1.46 0 .806-.64 1.46-1.43 1.46-.79 0-1.43-.654-1.43-1.46 0-.806.64-1.46 1.43-1.46z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    